import {
  IPrescriptionLabelModel,
  PrescriptionLabelModel,
} from '@common/models';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class PrescriptionLabelService {
  private static baseUrl: string = '/api/prescriptionlabel';

  static tags = {
    upsertPrescriptionLabel: 'upsertPrescriptionLabel',
    deletePrescriptionLabel: 'deletePrescriptionLabel',
  };

  static upsertPrescriptionLabel = (
    data: IPrescriptionLabelModel,
    options?: ServiceMethodOptions,
  ): Promise<PrescriptionLabelModel> => {
    return trackPromise(
      new Promise<IPrescriptionLabelModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IPrescriptionLabelModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess('Instruction Label updated.', options);
            resolve(new PrescriptionLabelModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError(
              'Failed to update Instruction Label.',
              options,
            );
            reject(err);
          });
      }),
      this.tags.upsertPrescriptionLabel,
    );
  };

  static deletePrescriptionLabel = (
    prescriptionlabelId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${prescriptionlabelId}`)
          .delete()
          .then(() => {
            ServiceHelper.showSuccess(
              'Instruction Label has been deleted.',
              options,
            );
            resolve(true);
          })
          .catch((err) => {
            ServiceHelper.showError(
              'Failed to delete Instruction Label.',
              options,
            );
            reject(err);
          });
      }),
      this.tags.deletePrescriptionLabel,
    );
  };
}
